import { gql } from '@apollo/client'

export default gql`
  fragment EmergencyContact on EmergencyContact {
    id
    firstName
    lastName
    phoneNumber
    emailAddress
    contactType
  }
`
